module.exports = __webpack_public_path__ + "img/cyan.8cc5e3c9.jpg";